<div class="kt-mat-snackbar">
  <div class="kt-mat-snackbar__message" style="width: 90%;" [innerHtml]="data.message | safeHtml">
    @if (data.showUndoButton) {
      <div class="kt-mat-snackbar__btn">
        <button  type="button" mat-button color="primary" (click)="onDismissWithAction()">
          {{ "common.undo" | translate }}
        </button>
      </div>
    }
  </div>
  <div class="kt-mat-snackbar__close" style="width: 10%;">
    @if (data.showCloseButton) {
      <button [attr.aria-label]="'aria.dismiss' | translate"
        mat-icon-button
        disableRipple
        (click)="onDismiss()">
        <mat-icon>clear</mat-icon>
      </button>
    }
  </div>
</div>
